module.exports = __webpack_public_path__ + "img/vien-uong-hapanix-1.969bf69f.jpg";